<template>
  <div v-if="configuration">
    <vs-tabs position="left" class="tabs-shadow-none mt-2" id="profile-tabs">
      <vs-tab icon-pack="feather" icon="icon-droplet" label="Pouring Categories">
        <configuration-pouring-categories />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-grid" label="Sales groups">
        <configuration-sales-groups />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-hash" label="Stock categories">
        <configuration-stock-categories />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-dollar-sign" label="Tax rates">
        <configuration-tax-groups />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-dollar-sign" label="Price groups">
        <configuration-price-groups />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-dollar-sign" label="Tip percentages">
        <configuration-tip-percentages />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-align-justify" label="Allergies">
        <ConfigurationAllergies />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-align-justify" label="Sales waste reasons">
        <configuration-sales-waste-reasons />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-align-justify" label="Stock waste reasons">
        <configuration-stock-waste-reasons />
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ConfigurationPouringCategories from "./ConfigurationPouringCategories.vue";
import ConfigurationSalesGroups from "./ConfigurationSalesGroups.vue";
import ConfigurationStockCategories from "./ConfigurationStockCategories.vue";
import ConfigurationTaxGroups from "./ConfigurationTaxGroups.vue";
import ConfigurationPriceGroups from "./ConfigurationPriceGroups.vue";
import ConfigurationSalesWasteReasons from "./ConfigurationSalesWasteReasons.vue";
import ConfigurationStockWasteReasons from "./ConfigurationStockWasteReasons.vue";
import ConfigurationAllergies from "./ConfigurationAllergies.vue";
import ConfigurationTipPercentages from "./ConfigurationTipPercentages.vue";

export default {
  components: {
    ConfigurationPouringCategories,
    ConfigurationSalesGroups,
    ConfigurationStockCategories,
    ConfigurationTaxGroups,
    ConfigurationPriceGroups,
    ConfigurationSalesWasteReasons,
    ConfigurationStockWasteReasons,
    ConfigurationAllergies,
    ConfigurationTipPercentages
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {},
  computed: {
    ...mapGetters({
      configuration: "pos/countrySettings/countrySettings"
    })
  },
  async created() {
    await this.$store.dispatch("pos/countrySettings/getCountrySettings");
  }
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}
</style>
